import React, {Fragment,  useState, useEffect} from "react";
import { Table, Button } from "react-bootstrap";

import '../../table_report.css';

const TablaRep1_finalizadosTotal = ({datosRP1_finalizadosTotal}) => {
  //console.log("CARGAR datos FINALIZADOS en tabla");
  //console.log(datosRP1_finalizadosTotal);

  if (datosRP1_finalizadosTotal === null) {
    return(
      <p>Seleccionar rango de fechas...</p>
    )
  } else if(datosRP1_finalizadosTotal !== null){
    return(
      <Fragment>
        <h4></h4>
        <p className="subtitulos">Proyectos y lotes finalizados</p>
        <div>
          <Table className="tableExp" stripped bordered hover responsive="md" style={{ marginBottom: '30px' }}>
            <thead>
              <tr style={{ backgroundColor: "rgb(0,174,195)", color: "white" }}>
                <th></th>
                <th>Lotes</th>
                <th>Proyectos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ fontWeight: 'bold' }}>Afectados con resolución</td>
                <td>{datosRP1_finalizadosTotal[0]?.suma_lotes_afectados || 0}</td>
                <td>{datosRP1_finalizadosTotal[0]?.suma_proyectos_afectados || 0}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: 'bold' }}>Rectificados</td>
                <td>{datosRP1_finalizadosTotal[0]?.suma_lotes_rectificados || 0}</td>
                <td>{datosRP1_finalizadosTotal[0]?.suma_proyectos_rectificados || 0}</td>
              </tr>
              <tr style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                <td>Total lotes generados</td>
                <td>{datosRP1_finalizadosTotal[0]?.suma_lotes || 0}</td>
                <td>{datosRP1_finalizadosTotal[0]?.suma_proyectos || 0}</td>
              </tr>
            </tbody>
          </Table>
          {/* tabla original con .map()
          <Table className="tableExp" stripped bordered hover responsive="md" >
            <thead>
              <tr style={{backgroundColor:"rgb(0,174,195)", color:"white"}}>
                <th>Total lotes</th>
                <th>Total proyectos</th>
              </tr>
            </thead>
            <tbody>
              {datosRP1_finalizadosTotal.map((item, i)=>(
                <tr key={i}>
                  <td>{item.suma_lotes}</td>
                  <td>{item.suma_proyectos}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          */}
        </div>
      </Fragment>
    )
  }
};

export default TablaRep1_finalizadosTotal;
